(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-bundle"] && !Shopify.designMode) return;
  try {
    
  class NoorBundle extends HTMLElement {
    connectedCallback() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.dataset.anim === 'false' || reduce) {
        this.classList.add('is-in');
        if (!reduce) this.classList.add('is-live');
        return;
      }

      // one-shot entrance
      this.reveal = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            this.classList.add('is-in');
            this.reveal.disconnect();
            this.reveal = null;
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      this.reveal.observe(this);

      // continuous motion runs only while the section is on screen,
      // so the halo and drift cost nothing further down the page
      this.live = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => this.classList.toggle('is-live', e.isIntersecting));
        },
        { threshold: 0 }
      );
      this.live.observe(this);
    }

    disconnectedCallback() {
      if (this.reveal) this.reveal.disconnect();
      if (this.live) this.live.disconnect();
      this.reveal = null;
      this.live = null;
    }
  }

  if (!customElements.get('noor-bundle')) {
    customElements.define('noor-bundle', NoorBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-creator-form"] && !Shopify.designMode) return;
  try {
    
  class NoorCreatorForm extends HTMLElement {
    connectedCallback() {
      // reveal on entry — an IntersectionObserver rather than a scroll
      // listener, so it still fires inside the editor's scroll container
      if (this.classList.contains('is-in')) return;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            this.classList.add('is-in');
            io.disconnect();
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
      );
      io.observe(this);
      this.io = io;

      // character counter
      const ta = this.querySelector('.nd-cf__ta');
      const count = this.querySelector('.nd-cf__count b');
      if (ta && count) {
        ta.addEventListener('input', () => {
          count.textContent = ta.value.length;
        });
      }

      // stop double submits, and let the button say so
      const form = this.querySelector('form');
      const btn = this.querySelector('.nd-cf__btn');
      if (form && btn) {
        form.addEventListener('submit', () => {
          if (!form.checkValidity()) return;
          btn.setAttribute('aria-busy', 'true');
        });
      }

      // move focus to the confirmation after a successful post
      const done = this.querySelector('.nd-cf__done');
      if (done) {
        done.focus({ preventScroll: true });
        done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-creator-form')) {
    customElements.define('noor-creator-form', NoorCreatorForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-duo"] && !Shopify.designMode) return;
  try {
    
  class NoorDuo extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.nd-duo__item'));
      this.visible = new Set();
      this.running = false;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.parallax = !reduce;

      // Reveal on entry. An IntersectionObserver rather than a scroll
      // listener, because the theme editor scrolls an inner container
      // and window scroll events never fire there.
      this.reveal = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            this.classList.add('is-in');
            this.reveal.disconnect();
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.06 }
      );
      this.reveal.observe(this);

      if (!this.parallax) return;

      // Track which panels are on screen, and only run the loop for those.
      this.track = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) this.visible.add(e.target);
            else {
              this.visible.delete(e.target);
              e.target.style.setProperty('--p', 0);
            }
          });
          if (this.visible.size && !this.running) this.start();
        },
        { threshold: 0 }
      );
      this.items.forEach((el) => this.track.observe(el));
    }

    start() {
      this.running = true;
      const step = () => {
        if (!this.isConnected || !this.visible.size) {
          this.running = false;
          return;
        }
        const vh = window.innerHeight || document.documentElement.clientHeight;
        this.visible.forEach((el) => {
          const r = el.getBoundingClientRect();
          // -1 when the panel sits below the fold, +1 when above it
          let p = (r.top + r.height / 2 - vh / 2) / vh;
          if (p > 1) p = 1;
          if (p < -1) p = -1;
          el.style.setProperty('--p', p.toFixed(4));
        });
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }

    disconnectedCallback() {
      if (this.reveal) this.reveal.disconnect();
      if (this.track) this.track.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.running = false;
    }
  }

  if (!customElements.get('noor-duo')) {
    customElements.define('noor-duo', NoorDuo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-image-text"] && !Shopify.designMode) return;
  try {
    
  class NoorImageText extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-in');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

      this.io.observe(this);

      if (this.dataset.parallax === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.#drift();
      }
    }

    disconnectedCallback() {
      this.active = false;
      if (this.io) this.io.disconnect();
      if (this.pio) this.pio.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    /* rAF rather than scroll events — the theme may scroll an
       inner container, where scroll never reaches window */
    #drift() {
      const tick = () => {
        if (!this.active) { this.raf = null; return; }

        const r = this.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1);

        if (p !== this._p) {
          this._p = p;
          this.style.setProperty('--it-p', (p * 2 - 1).toFixed(4));
        }

        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      this.pio = new IntersectionObserver((entries) => {
        this.active = entries[0].isIntersecting;
        if (this.active) play();
      }, { rootMargin: '150px 0px 150px 0px' });

      this.pio.observe(this);
    }
  }

  if (!customElements.get('noor-image-text')) customElements.define('noor-image-text', NoorImageText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-power-duo"] && !Shopify.designMode) return;
  try {
    
  class NoorPowerDuo extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.boxes = Array.from(this.querySelectorAll('.nd-pw__box'));
      this.sided = Array.from(this.querySelectorAll('[data-side]'));

      this.setFloatTimings();
      this.watchEntrance();
      this.bindFocus();
      this.bindParallax();
    }

    /* each bottle drifts on its own clock, so they never sync up */
    setFloatTimings() {
      const durations = [6.4, 7.8];
      const delays = [0, -1.6];
      this.boxes.forEach((box, i) => {
        box.style.setProperty('--dur', durations[i % 2] + 's');
        box.style.setProperty('--del', delays[i % 2] + 's');
      });
    }

    /* IntersectionObserver, not a scroll listener — the theme editor
       scrolls an inner container where window scroll never fires */
    watchEntrance() {
      if (this.dataset.anim === 'false') {
        this.classList.add('is-in');
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            this.classList.add('is-in');
            this.io.disconnect();
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      this.io.observe(this);
    }

    /* hovering or tabbing into one product marks it active and lets the
       other recede. Media and copy live in different grid rows, so the
       pairing is done here rather than with a CSS sibling selector. */
    bindFocus() {
      const groups = this.sided;

      const activate = (side) => {
        this.setAttribute('data-side-hover', side);
        groups.forEach((el) => {
          if (el.dataset.side === side) el.setAttribute('data-side-active', '');
          else el.removeAttribute('data-side-active');
        });
      };

      const clear = () => {
        this.removeAttribute('data-side-hover');
        groups.forEach((el) => el.removeAttribute('data-side-active'));
      };

      groups.forEach((el) => {
        const side = el.dataset.side;
        el.addEventListener('pointerenter', () => activate(side));
        el.addEventListener('focusin', () => activate(side));
      });

      this.addEventListener('pointerleave', clear);
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) clear();
      });
    }

    /* pointer parallax, desktop only, rAF-throttled to one write per frame */
    bindParallax() {
      if (this.reduce) return;
      if (this.dataset.parallax === 'false') return;
      if (!window.matchMedia('(hover: hover) and (min-width: 750px)').matches) return;

      this.orbits = Array.from(this.querySelectorAll('.nd-pw__orbit'));
      if (!this.orbits.length) return;

      let queued = false;
      let mx = 0;
      let my = 0;

      this.onMove = (e) => {
        const r = this.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - r.top) / r.height - 0.5;
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          this.orbits.forEach((o, i) => {
            // the two bottles drift in opposite directions
            const dir = i % 2 === 0 ? 1 : -1;
            o.style.setProperty('--mx', (mx * dir).toFixed(3));
            o.style.setProperty('--my', (my * dir).toFixed(3));
          });
          queued = false;
        });
      };

      this.onLeave = () => {
        this.orbits.forEach((o) => {
          o.style.setProperty('--mx', 0);
          o.style.setProperty('--my', 0);
        });
      };

      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerleave', this.onLeave);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onMove) this.removeEventListener('pointermove', this.onMove);
      if (this.onLeave) this.removeEventListener('pointerleave', this.onLeave);
    }
  }

  if (!customElements.get('noor-power-duo')) {
    customElements.define('noor-power-duo', NoorPowerDuo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-rich-text"] && !Shopify.designMode) return;
  try {
    
  class NoorRichText extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-in');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-rich-text')) customElements.define('noor-rich-text', NoorRichText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-search-results"]) return;
  try {
    
  class NoorSearch extends HTMLElement {
    connectedCallback() {
      this.#reveal();
      this.#swatches();
      this.#quickAdd();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.02 });

      this.io.observe(this);
    }

    #swatches() {
      this.querySelectorAll('[data-swatch]').forEach((sw) => {
        sw.addEventListener('mouseenter', () => this.#swap(sw));
        sw.addEventListener('click', (e) => { e.preventDefault(); this.#swap(sw); });
      });
    }

    #swap(sw) {
      const src = sw.dataset.img;
      if (!src) return;

      const card = sw.closest('.nd-coll__card');
      const img = card && card.querySelector('.nd-coll__img--a');
      if (!img) return;

      img.src = src;
      img.removeAttribute('srcset');

      card.querySelectorAll('[data-swatch]').forEach((n) => n.classList.remove('is-active'));
      sw.classList.add('is-active');
    }

    #quickAdd() {
      this.querySelectorAll('form[data-quick-add]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const btn = form.querySelector('button');
          const label = form.querySelector('[data-label]');
          const original = label ? label.textContent : '';

          btn.classList.add('is-loading');
          btn.disabled = true;

          try {
            const res = await fetch(this.dataset.addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            });

            if (!res.ok) throw new Error('add failed');

            if (label) label.textContent = 'Added ✓';

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

            if (this.dataset.afterAdd === 'cart') { window.location.href = '/cart'; return; }

            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } catch (err) {
            if (label) label.textContent = 'Try again';
            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } finally {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        });
      });
    }
  }

  if (!customElements.get('noor-search')) customElements.define('noor-search', NoorSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-story-page"] && !Shopify.designMode) return;
  try {
    
  class NoorStoryPage extends HTMLElement {
    connectedCallback() {
      const items = this.querySelectorAll('.nd-os__reveal');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-in'));
        return;
      }

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            this.io.unobserve(e.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.04 }
      );

      items.forEach((el) => this.io.observe(el));
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-story-page')) customElements.define('noor-story-page', NoorStoryPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-collection"] && !Shopify.designMode) return;
  try {
    
  class NoorCollection extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-rail]');
      this.progress = this.querySelector('[data-progress]');
      this.arrows = this.querySelectorAll('.nd-coll__arrow');

      this.#reveal();
      this.#swatches();
      this.#quickAdd();

      if (this.dataset.layout === 'rail' && this.viewport) {
        this.#drag();
        this.#nav();
        this.viewport.addEventListener('scroll', () => this.#sync(), { passive: true });
        this.#sync();
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.classList.add('is-visible'); this.io.disconnect(); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });

      this.io.observe(this);
    }

    #swatches() {
      this.querySelectorAll('[data-swatch]').forEach((sw) => {
        sw.addEventListener('mouseenter', () => this.#swap(sw));
        sw.addEventListener('click', (e) => { e.preventDefault(); this.#swap(sw); });
      });
    }

    #swap(sw) {
      const src = sw.dataset.img;
      if (!src) return;

      const card = sw.closest('.nd-coll__card');
      const img = card && card.querySelector('.nd-coll__img--a');
      if (!img) return;

      img.src = src;
      img.removeAttribute('srcset');

      card.querySelectorAll('[data-swatch]').forEach((n) => n.classList.remove('is-active'));
      sw.classList.add('is-active');
    }

    /* Pointer capture retargets the click to the capturing element,
       which stops links inside from ever receiving it. So we only
       capture once the pointer has actually moved past the drag
       threshold — a plain click never captures, and navigates. */
    #drag() {
      const vp = this.viewport;
      let down = false, dragging = false, startX = 0, startLeft = 0;

      vp.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true;
        dragging = false;
        startX = e.clientX;
        startLeft = vp.scrollLeft;
      });

      vp.addEventListener('pointermove', (e) => {
        if (!down) return;

        const dx = e.clientX - startX;

        if (!dragging) {
          if (Math.abs(dx) <= 4) return;   // still just a click
          dragging = true;
          vp.classList.add('is-dragging');
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }

        e.preventDefault();
        vp.scrollLeft = startLeft - dx;
      });

      const end = (e) => {
        if (!down) return;
        down = false;

        if (!dragging) return;
        dragging = false;

        try { vp.releasePointerCapture(e.pointerId); } catch (err) {}
        // held just long enough to swallow the click that follows a drag
        setTimeout(() => vp.classList.remove('is-dragging'), 40);
      };

      vp.addEventListener('pointerup', end);
      vp.addEventListener('pointercancel', end);
      vp.addEventListener('pointerleave', end);
    }

    #nav() {
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.querySelector('.nd-coll__card');
          const gap = parseFloat(getComputedStyle(this.querySelector('.nd-coll__items')).columnGap) || 24;
          const step = card ? card.offsetWidth + gap : this.viewport.clientWidth * 0.8;
          this.viewport.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    }

    #sync() {
      const vp = this.viewport;
      const max = vp.scrollWidth - vp.clientWidth;
      const p = max > 0 ? vp.scrollLeft / max : 0;

      if (this.progress) {
        const w = parseFloat(getComputedStyle(this.progress).width);
        const track = this.progress.parentElement.clientWidth;
        this.progress.style.transform = `translateX(${(p * (track - w)).toFixed(1)}px)`;
      }

      this.arrows.forEach((b) => {
        b.disabled = b.dataset.dir === 'prev' ? vp.scrollLeft <= 2 : vp.scrollLeft >= max - 2;
      });
    }

    #quickAdd() {
      this.querySelectorAll('form[data-quick-add]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const btn = form.querySelector('button');
          const label = form.querySelector('[data-label]');
          const original = label ? label.textContent : '';

          btn.classList.add('is-loading');
          btn.disabled = true;

          try {
            const res = await fetch(this.dataset.addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });

            if (!res.ok) throw new Error('add failed');

            if (label) label.textContent = 'Added ✓';

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

            if (this.dataset.afterAdd === 'cart') { window.location.href = '/cart'; return; }

            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } catch (err) {
            if (label) label.textContent = 'Try again';
            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } finally {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        });
      });
    }
  }

  if (!customElements.get('noor-collection')) customElements.define('noor-collection', NoorCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-gallery"] && !Shopify.designMode) return;
  try {
    
  class NoorGallery extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-row]'));
      if (!this.rows.length) return;

      this.speed = parseFloat(this.dataset.speed) || 55;
      this.pause = this.dataset.pause === 'true';

      this.#reveal();
      this.#build();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.#build());
        this.ro.observe(this);
      }

      if (this.pause) {
        this.rows.forEach((row) => {
          const track = row.querySelector('[data-track]');
          row.addEventListener('pointerenter', () => { track.style.animationPlayState = 'paused'; });
          row.addEventListener('pointerleave', () => { track.style.animationPlayState = 'running'; });
        });
      }

      if (this.dataset.react === 'true') this.#react();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.revealIo) this.revealIo.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.revealIo = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.revealIo.disconnect();
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.03 });

      this.revealIo.observe(this);
    }

    /* Measure one group, clone it until the row is covered twice over,
       then animate by exactly one group width. Seamless at any size. */
    #build() {
      this.rows.forEach((row, i) => {
        const track = row.querySelector('[data-track]');
        const group = row.querySelector('[data-group]');
        if (!track || !group) return;

        track.querySelectorAll('[data-clone]').forEach((n) => n.remove());

        const w = group.offsetWidth;
        if (!w) return;

        // each row a little slower than the one above → depth without 3D
        const factor = 1 - i * 0.16;
        const speed = Math.max(this.speed * factor, 8);

        row.style.setProperty('--nd-w', w + 'px');
        row.style.setProperty('--nd-dur', (w / speed).toFixed(2) + 's');

        const copies = Math.ceil((row.offsetWidth * 2) / w) + 1;
        const frag = document.createDocumentFragment();

        for (let c = 0; c < copies; c++) {
          const clone = group.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          frag.appendChild(clone);
        }

        track.appendChild(frag);
      });
    }

    /* Reads its own movement per frame — works whatever is scrolling. */
    #react() {
      this.vel = 0;
      this.lastTop = this.getBoundingClientRect().top;

      const tick = () => {
        if (!this.active) { this.raf = null; this.#rate(1); return; }

        const top = this.getBoundingClientRect().top;
        const moved = Math.abs(top - this.lastTop);
        this.lastTop = top;

        this.vel = Math.max(this.vel * 0.9, Math.min(moved / 4, 5));
        this.#rate(1 + this.vel);

        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) play();
        }, { rootMargin: '150px 0px 150px 0px' });
        this.io.observe(this);
      } else {
        this.active = true;
        play();
      }
    }

    #rate(r) {
      this.rows.forEach((row) => {
        const track = row.querySelector('[data-track]');
        if (!track || !track.getAnimations) return;
        track.getAnimations().forEach((a) => { a.playbackRate = r; });
      });
    }
  }

  if (!customElements.get('noor-gallery')) customElements.define('noor-gallery', NoorGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-grid"] && !Shopify.designMode) return;
  try {
    
  class NoorGrid extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-grid')) customElements.define('noor-grid', NoorGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-hero"] && !Shopify.designMode) return;
  try {
    
  class NoorHero extends HTMLElement {
    connectedCallback() {
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-visible'));
      });

      if (this.dataset.parallax === 'true' && !this.reduced) this.#initParallax();
    }

    disconnectedCallback() {
      this.active = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
    }

    /* rAF loop rather than window scroll events — the theme may scroll an
       inner container, in which case scroll never reaches window. */
    #initParallax() {
      const tick = () => {
        if (!this.active) { this.raf = null; return; }
        this.#update();
        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) play();
        }, { rootMargin: '200px 0px 200px 0px' });
        this.io.observe(this);
      } else {
        this.active = true;
        play();
      }

      this.#update();
    }

    #update() {
      const r = this.getBoundingClientRect();
      const p = Math.min(Math.max(-r.top / Math.max(r.height, 1), 0), 1);
      if (p === this._p) return;
      this._p = p;
      this.style.setProperty('--nd-p', p.toFixed(4));
    }
  }

  if (!customElements.get('noor-hero')) customElements.define('noor-hero', NoorHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-index"] && !Shopify.designMode) return;
  try {
    
  class NoorIndex extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');
      this.float = this.querySelector('[data-float]');
      this.rows = Array.from(this.querySelectorAll('[data-row]'));
      this.items = Array.from(this.querySelectorAll('[data-float-item]'));

      this.#reveal();

      const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!fine || this.dataset.follow !== 'true' || !this.float || !this.rows.length) return;

      this.ease = (parseFloat(this.dataset.ease) || 12) / 100;
      this.x = 0; this.y = 0;
      this.tx = 0; this.ty = 0;
      this.active = false;

      this.#bind();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

      this.io.observe(this);
    }

    #bind() {
      this.onMove = (e) => {
        this.tx = e.clientX;
        this.ty = e.clientY;
        if (!this.raf) this.raf = requestAnimationFrame(() => this.#loop());
      };

      this.list.addEventListener('pointermove', this.onMove);

      this.list.addEventListener('pointerenter', () => {
        this.list.classList.add('is-hovering');
        this.float.classList.add('is-on');
        this.active = true;
        // drop the image at the cursor rather than sliding it in from 0,0
        this.x = this.tx; this.y = this.ty;
        if (!this.raf) this.raf = requestAnimationFrame(() => this.#loop());
      });

      this.list.addEventListener('pointerleave', () => {
        this.list.classList.remove('is-hovering');
        this.float.classList.remove('is-on');
        this.active = false;
        this.rows.forEach((r) => r.classList.remove('is-on'));
      });

      this.rows.forEach((row) => {
        row.addEventListener('pointerenter', () => {
          this.rows.forEach((r) => r.classList.toggle('is-on', r === row));
          const i = row.dataset.index;
          this.items.forEach((it) => it.classList.toggle('is-on', it.dataset.floatItem === i));
        });
      });
    }

    #loop() {
      this.raf = null;

      const w = this.float.offsetWidth || 320;
      const h = this.float.offsetHeight || 400;

      this.x += (this.tx - this.x) * this.ease;
      this.y += (this.ty - this.y) * this.ease;

      // lean into the direction of travel — small, but it sells the weight
      const skew = Math.max(-8, Math.min((this.tx - this.x) * 0.35, 8));

      this.float.style.transform =
        'translate3d(' + (this.x - w / 2) + 'px,' + (this.y - h / 2) + 'px,0) rotate(' + skew.toFixed(2) + 'deg)';

      const settled = Math.abs(this.tx - this.x) < 0.4 && Math.abs(this.ty - this.y) < 0.4;
      if (this.active && !settled) this.raf = requestAnimationFrame(() => this.#loop());
    }
  }

  if (!customElements.get('noor-index')) customElements.define('noor-index', NoorIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-marquee"] && !Shopify.designMode) return;
  try {
    
  class NoorMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nd-mq__track');
      this.group = this.querySelector('.nd-mq__group');
      if (!this.track || !this.group) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.speed = parseFloat(this.dataset.speed) || 60;

      this.#build();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.#build());
        this.ro.observe(this);
      }

      if (this.dataset.scrollReact === 'true' && !this.reduced) this.#initScroll();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    #build() {
      this.track.querySelectorAll('.nd-mq__group[data-clone]').forEach((n) => n.remove());

      const w = this.group.offsetWidth;
      if (!w) return;

      this.style.setProperty('--nd-mq-w', w + 'px');
      this.style.setProperty('--nd-mq-dur', (w / this.speed).toFixed(2) + 's');

      const copies = Math.ceil((this.offsetWidth * 2) / w) + 1;
      const frag = document.createDocumentFragment();

      for (let i = 0; i < copies; i++) {
        const c = this.group.cloneNode(true);
        c.setAttribute('data-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
        c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        frag.appendChild(c);
      }

      this.track.appendChild(frag);
    }

    /* Measures its own movement per frame instead of listening for window
       scroll — works whether the page, an inner container, or a smooth
       scroll layer is doing the scrolling. Only runs while on screen. */
    #initScroll() {
      this.vel = 0;
      this.lastTop = this.getBoundingClientRect().top;

      const tick = () => {
        if (!this.active) { this.raf = null; this.#rate(1); return; }

        const top = this.getBoundingClientRect().top;
        const moved = Math.abs(top - this.lastTop);
        this.lastTop = top;

        this.vel = Math.max(this.vel * 0.9, Math.min(moved / 3, 7));
        this.#rate(1 + this.vel);

        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) play();
        }, { rootMargin: '100px 0px 100px 0px' });
        this.io.observe(this);
      } else {
        this.active = true;
        play();
      }
    }

    #rate(r) {
      if (!this.track.getAnimations) return;
      this.track.getAnimations().forEach((a) => { a.playbackRate = r; });
    }
  }

  if (!customElements.get('noor-marquee')) customElements.define('noor-marquee', NoorMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-product"] && !Shopify.designMode) return;
  try {
    
  class NoorProduct extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.counter = this.querySelector('[data-counter]');
      this.stage = this.querySelector('[data-stage]');
      this.index = 0;

      const data = this.querySelector('[data-variants]');
      try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }

      this.form = this.querySelector('.nd-pd__form');
      this.variantInput = this.querySelector('[data-variant-input]');

      // remember the original button wording so states can restore it
      const lbl = this.querySelector('[data-add-label]');
      this.addLabel = lbl ? lbl.textContent.trim() : 'Add to bag';

      this.#gallery();
      this.#options();
      this.#quantity();
      this.#cart();
      this.#lightbox();
      this.#stickyBar();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      document.documentElement.style.overflow = '';
    }

    /* ── gallery ─────────────────────────────────────── */
    #gallery() {
      if (!this.slides.length) return;

      this.thumbs.forEach((t) => t.addEventListener('click', () => this.#show(parseInt(t.dataset.index, 10))));
      this.dots.forEach((d) => d.addEventListener('click', () => this.#show(parseInt(d.dataset.index, 10))));

      this.querySelectorAll('[data-dir]').forEach((b) => {
        b.addEventListener('click', () => this.#show(this.index + (b.dataset.dir === 'next' ? 1 : -1)));
      });

      // swipe
      let x0 = null, y0 = null;
      this.stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; });
      this.stage.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        const dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        this.#show(this.index + (dx < 0 ? 1 : -1));
      });
    }

    #show(next) {
      const n = this.slides.length;
      const i = ((next % n) + n) % n;
      if (i === this.index) return;
      this.index = i;

      this.slides.forEach((sl, k) => sl.classList.toggle('is-on', k === i));
      this.thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      this.dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (this.counter) this.counter.textContent = i + 1;

      // keep the active thumbnail in view
      const t = this.thumbs[i];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    #showMedia(mediaId) {
      if (!mediaId) return;
      const idx = this.slides.findIndex((sl) => sl.dataset.mediaId === String(mediaId));
      if (idx > -1) this.#show(idx);
    }

    /* ── variant options ─────────────────────────────── */
    #options() {
      this.optionButtons = Array.from(this.querySelectorAll('[data-value]'));
      if (!this.optionButtons.length) { this.#syncAvailability(); return; }

      this.optionGroups = Array.from(this.querySelectorAll('[data-option]'));
      this.selected = this.optionGroups.map((g) => {
        const on = g.querySelector('[data-value].is-on');
        return on ? on.dataset.valueName : null;
      });

      this.optionButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const oi = parseInt(btn.dataset.optionIndex, 10);
          this.selected[oi] = btn.dataset.valueName;

          this.optionGroups[oi].querySelectorAll('[data-value]').forEach((b) => {
            b.classList.toggle('is-on', b === btn);
          });

          const label = this.optionGroups[oi].querySelector('[data-option-value]');
          if (label) label.textContent = btn.dataset.valueName;

          this.#applyVariant();
        });
      });

      this.#syncAvailability();
    }

    #match() {
      return this.variants.find((v) =>
        this.selected.every((sel, i) => sel === null || v.options[i] === sel)
      );
    }

    #applyVariant() {
      const v = this.#match();
      this.#syncAvailability();
      if (!v) { this.#setSoldOut(true, 'unavailable'); return; }

      if (this.variantInput) this.variantInput.value = v.id;

      const price = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare]');
      const save = this.querySelector('[data-save]');
      const barPrice = this.querySelector('[data-bar-price]');

      if (price) price.textContent = v.price;
      if (barPrice) barPrice.textContent = v.price;

      if (compare) {
        compare.textContent = v.compare || '';
        compare.hidden = !v.compare;
      }
      if (save) save.hidden = !v.compare;

      const skuLine = this.querySelector('[data-sku-line]');
      const sku = this.querySelector('[data-sku]');
      if (sku) sku.textContent = v.sku || '';
      if (skuLine) skuLine.hidden = !v.sku;

      this.#setSoldOut(!v.available);
      this.#showMedia(v.media);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    /* grey out values that produce no purchasable variant */
    #syncAvailability() {
      if (!this.optionGroups || !this.optionGroups.length) return;

      this.optionGroups.forEach((group, oi) => {
        group.querySelectorAll('[data-value]').forEach((btn) => {
          const test = this.selected.slice();
          test[oi] = btn.dataset.valueName;

          const exists = this.variants.some((v) =>
            v.available && test.every((sel, i) => sel === null || v.options[i] === sel)
          );

          btn.classList.toggle('is-out', !exists);
        });
      });
    }

    #setSoldOut(out, reason) {
      const btn = this.querySelector('[data-add]');
      const label = this.querySelector('[data-add-label]');
      const bar = this.querySelector('[data-bar-add]');
      if (!btn) return;

      btn.disabled = out;
      if (bar) bar.disabled = out;

      if (!label) return;
      if (!out) { label.textContent = this.addLabel; return; }

      label.textContent = reason === 'unavailable' ? 'Unavailable' : 'Sold out';
    }

    /* ── quantity ────────────────────────────────────── */
    #quantity() {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;

      this.querySelectorAll('[data-qty]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.qty, 10);
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    }

    /* ── add to cart ─────────────────────────────────── */
    #cart() {
      if (!this.form) return;

      const submit = async (e) => {
        if (e) e.preventDefault();

        const btn = this.querySelector('[data-add]');
        const label = this.querySelector('[data-add-label]');
        const original = this.addLabel;

        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });

          if (!res.ok) throw new Error('add failed');

          if (label) label.textContent = 'Added ✓';

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

          if (this.dataset.afterAdd === 'cart') { window.location.href = '/cart'; return; }

          setTimeout(() => { if (label) label.textContent = original; }, 1800);
        } catch (err) {
          if (label) label.textContent = 'Try again';
          setTimeout(() => { if (label) label.textContent = original; }, 1800);
        } finally {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        }
      };

      this.form.addEventListener('submit', submit);

      const bar = this.querySelector('[data-bar-add]');
      if (bar) bar.addEventListener('click', () => submit());
    }

    /* ── lightbox ────────────────────────────────────── */
    #lightbox() {
      this.lb = this.querySelector('[data-lightbox]');
      if (!this.lb || this.dataset.zoom !== 'true') return;

      const lbStage = this.lb.querySelector('[data-lb-stage]');

      const open = () => {
        const img = this.slides[this.index].querySelector('img');
        if (!img) return;

        lbStage.innerHTML = '';
        const clone = new Image();
        clone.src = img.currentSrc || img.src;
        clone.alt = img.alt || '';
        lbStage.appendChild(clone);

        this.lb.hidden = false;
        requestAnimationFrame(() => this.lb.classList.add('is-on'));
        document.documentElement.style.overflow = 'hidden';
      };

      const close = () => {
        this.lb.classList.remove('is-on');
        document.documentElement.style.overflow = '';
        setTimeout(() => { this.lb.hidden = true; }, 400);
      };

      const step = (d) => { this.#show(this.index + d); open(); };

      this.querySelectorAll('[data-open-zoom]').forEach((b) => b.addEventListener('click', open));
      this.stage.addEventListener('dblclick', open);
      this.lb.querySelector('[data-lb-close]').addEventListener('click', close);
      this.lb.querySelectorAll('[data-lb-dir]').forEach((b) => {
        b.addEventListener('click', () => step(b.dataset.lbDir === 'next' ? 1 : -1));
      });

      this.lb.addEventListener('click', (e) => { if (e.target === this.lb) close(); });

      this.onKey = (e) => {
        if (this.lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') step(1);
        if (e.key === 'ArrowLeft') step(-1);
      };

      document.addEventListener('keydown', this.onKey);
    }

    /* ── sticky bar ──────────────────────────────────── */
    #stickyBar() {
      const bar = this.querySelector('[data-bar]');
      const buy = this.querySelector('.nd-pd__buy');
      if (!bar || !buy || this.dataset.stickyBar !== 'true') return;

      if (!('IntersectionObserver' in window)) return;

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });

      this.io.observe(buy);
    }
  }

  if (!customElements.get('noor-product')) customElements.define('noor-product', NoorProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-social"] && !Shopify.designMode) return;
  try {
    
  class NoorSocial extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });

      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-social')) customElements.define('noor-social', NoorSocial);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-spotlight"] && !Shopify.designMode) return;
  try {
    
  class NoorSpotlight extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.shots = Array.from(this.querySelectorAll('[data-shot]'));
      this.rail = this.querySelector('[data-rail]');
      this.railBox = this.querySelector('.nd-sp__rail');

      this.#reveal();
      this.#quickAdd();

      if (!this.steps.length) return;

      // A step becomes active when it crosses the middle of the screen.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) this.#activate(e.target); });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

        this.steps.forEach((st) => this.io.observe(st));
      } else {
        this.#activate(this.steps[0]);
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.revealIo) this.revealIo.disconnect();
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.revealIo = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.revealIo.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.03 });

      this.revealIo.observe(this);
    }

    #activate(step) {
      const i = step.dataset.index;
      if (i === this._active) return;
      this._active = i;

      this.steps.forEach((st) => st.classList.toggle('is-on', st === step));

      // fall back to the base shot when this step has no image of its own
      const own = this.shots.find((sh) => sh.dataset.shot === i);
      const target = own || this.shots.find((sh) => sh.dataset.shot === 'base');
      this.shots.forEach((sh) => sh.classList.toggle('is-on', sh === target));

      if (this.rail && this.railBox) {
        const pct = ((parseInt(i, 10) + 1) / this.steps.length) * 100;
        this.rail.style.height = pct.toFixed(2) + '%';
      }
    }

    #quickAdd() {
      this.querySelectorAll('form[data-quick-add]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const btn = form.querySelector('button');
          const label = form.querySelector('[data-label]');
          const original = label ? label.textContent : '';

          btn.classList.add('is-loading');
          btn.disabled = true;

          try {
            const res = await fetch(this.dataset.addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });

            if (!res.ok) throw new Error('add failed');

            if (label) label.textContent = 'Added ✓';

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

            if (this.dataset.afterAdd === 'cart') { window.location.href = '/cart'; return; }

            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } catch (err) {
            if (label) label.textContent = 'Try again';
            setTimeout(() => { if (label) label.textContent = original; }, 1800);
          } finally {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        });
      });
    }
  }

  if (!customElements.get('noor-spotlight')) customElements.define('noor-spotlight', NoorSpotlight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-statement"] && !Shopify.designMode) return;
  try {
    
  class NoorStatement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nd-st__track');
      this.textEl = this.querySelector('.nd-st__text');
      this.words = Array.from(this.querySelectorAll('.nd-st__w'));
      this.total = this.words.length;
      this.sticky = this.dataset.sticky === 'true';

      const dim = parseFloat(getComputedStyle(this).getPropertyValue('--nd-dim'));
      this.dim = isNaN(dim) ? 0.16 : dim;

      this.#releaseThemeAnimations();

      requestAnimationFrame(() => this.classList.add('is-visible'));

      if (!this.total) return;

      // Do NOT depend on window scroll events: if the theme scrolls an
      // inner container (or a smooth-scroll layer), scroll never reaches
      // window and this would only ever update on load. A rAF loop while
      // the section is on screen works with any scrolling mechanism.
      this.#watch();

      // fonts change the text height, which changes the reveal window
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.#update());
      }

      this.#update();
    }

    disconnectedCallback() {
      this.active = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
    }

    #watch() {
      const tick = () => {
        if (!this.active) { this.raf = null; return; }
        this.#update();
        this.raf = requestAnimationFrame(tick);
      };

      this.play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) this.play();
          else this.#update();
        }, { rootMargin: '300px 0px 300px 0px' });

        this.io.observe(this);
      } else {
        this.active = true;
        this.play();
      }
    }

    /* The theme may tag section content for its own scroll reveal.
       On these specific nodes that fights the word-by-word effect,
       so we detach it here — scoped strictly to this section. */
    #releaseThemeAnimations() {
      const scope = this.textEl ? [this.textEl, ...this.textEl.querySelectorAll('*')] : [];

      scope.forEach((el) => {
        Array.from(el.attributes || []).forEach((a) => {
          if (/^data-(animate|animation|cascade|scroll)/.test(a.name)) el.removeAttribute(a.name);
        });

        Array.from(el.classList || []).forEach((c) => {
          if (/animate|scroll-trigger|reveal/i.test(c)) el.classList.remove(c);
        });

        if (el.getAnimations) el.getAnimations().forEach((a) => a.cancel());
      });
    }

    #update() {
      const vh = window.innerHeight;
      let p;

      if (this.sticky) {
        const r = (this.track || this).getBoundingClientRect();
        p = -r.top / Math.max(r.height - vh, 1);
      } else {
        // Measured on the TEXT, not the padded block, so the reveal always
        // spans the window where the text is actually on screen.
        const r = (this.textEl || this).getBoundingClientRect();
        const START = vh * 0.78;  // text top here    →   0%
        const END = vh * 0.30;    // text bottom here → 100%
        p = (START - r.top) / Math.max(r.height + (START - END), 1);
      }

      p = Math.min(Math.max(p, 0), 1);
      if (p === this._p) return;
      this._p = p;

      const eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      const head = eased * (this.total + 2);

      for (let i = 0; i < this.total; i++) {
        const o = Math.min(Math.max(head - i, this.dim), 1);
        const w = this.words[i];
        if (w._o === o) continue;
        // `important` so a theme scroll-animation cannot outrank it
        w.style.setProperty('opacity', o.toFixed(3), 'important');
        w._o = o;
      }
    }
  }

  if (!customElements.get('noor-statement')) customElements.define('noor-statement', NoorStatement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-story"] && !Shopify.designMode) return;
  try {
    
  class NoorStory extends HTMLElement {
    connectedCallback() {
      this.#reveal();
      if (this.dataset.parallax === 'true') this.#parallax();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.pio) this.pio.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

      this.io.observe(this);
    }

    /* rAF loop, not scroll events — the theme may scroll an inner container */
    #parallax() {
      const tick = () => {
        if (!this.active) { this.raf = null; return; }

        const r = this.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1);

        if (p !== this._p) {
          this._p = p;
          this.style.setProperty('--nd-p', (p * 2 - 1).toFixed(4));
        }

        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.pio = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) play();
        }, { rootMargin: '200px 0px 200px 0px' });
        this.pio.observe(this);
      } else {
        this.active = true;
        play();
      }
    }
  }

  if (!customElements.get('noor-story')) customElements.define('noor-story', NoorStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noor-testimonials"] && !Shopify.designMode) return;
  try {
    
  class NoorTestimonials extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.progress = this.querySelector('[data-progress]');
      this.current = this.querySelector('[data-current]');
      this.stage = this.querySelector('[data-stage]');

      this.index = 0;
      this.count = this.slides.length;

      this.#reveal();
      if (this.count < 2) return;

      this.#bind();

      this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.paused = false;

      if (this.autoplay) this.#start();
    }

    disconnectedCallback() {
      this.stopped = true;
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    #reveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-visible'); return; }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-visible');
          this.io.disconnect();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

      this.io.observe(this);
    }

    #bind() {
      this.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.#go(this.index + (btn.dataset.dir === 'next' ? 1 : -1));
          this.#restart();
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.#go(parseInt(dot.dataset.index, 10));
          this.#restart();
        });
      });

      // pause while the visitor is reading
      ['pointerenter', 'focusin'].forEach((ev) =>
        this.addEventListener(ev, () => { this.paused = true; })
      );
      ['pointerleave', 'focusout'].forEach((ev) =>
        this.addEventListener(ev, () => { this.paused = false; })
      );

      // swipe
      let x0 = null;
      this.stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
      this.stage.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        this.#go(this.index + (dx < 0 ? 1 : -1));
        this.#restart();
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.#go(this.index + 1); this.#restart(); }
        if (e.key === 'ArrowLeft') { this.#go(this.index - 1); this.#restart(); }
      });
    }

    #go(next) {
      const i = ((next % this.count) + this.count) % this.count;
      if (i === this.index) return;
      this.index = i;

      this.slides.forEach((sl, n) => {
        const on = n === i;
        sl.classList.toggle('is-on', on);
        if (on) sl.removeAttribute('aria-hidden');
        else sl.setAttribute('aria-hidden', 'true');
      });

      this.dots.forEach((d, n) => d.classList.toggle('is-on', n === i));

      if (this.current) this.current.textContent = String(i + 1).padStart(2, '0');
    }

    #start() {
      this.t0 = performance.now();

      const tick = (now) => {
        if (this.stopped) return;

        if (this.paused) this.t0 = now - this.elapsed;
        else this.elapsed = now - this.t0;

        const p = Math.min(this.elapsed / this.speed, 1);
        if (this.progress) this.progress.style.transform = 'scaleX(' + p.toFixed(4) + ')';

        if (p >= 1) { this.#go(this.index + 1); this.t0 = now; this.elapsed = 0; }

        this.raf = requestAnimationFrame(tick);
      };

      this.elapsed = 0;
      this.raf = requestAnimationFrame(tick);
    }

    #restart() {
      this.t0 = performance.now();
      this.elapsed = 0;
      if (this.progress) this.progress.style.transform = 'scaleX(0)';
    }
  }

  if (!customElements.get('noor-testimonials')) customElements.define('noor-testimonials', NoorTestimonials);

  } catch(e) { console.error(e); }
})();
})();
